/** Max length for free-text fields (exception messages, breadcrumb messages). */
export const MAX_FREE_TEXT_LENGTH = 500;

const TRUNCATION_MARKER = '…[truncated]';

/**
 * Cap free-text length. A secondary defense after redaction: shorter text carries a
 * smaller chance of an embedded identifier the detectors did not catch.
 */
export const truncate = (value: string, max = MAX_FREE_TEXT_LENGTH): string =>
  value.length > max ? `${value.slice(0, max)}${TRUNCATION_MARKER}` : value;
